import React from 'react'
import Subheader from '../../component/Subheader'
import CraftpreservationText from './CraftpreservationText'

export default function CraftPreservation() {
    const subheadData = {
      image: '../image/craft-banner.webp',
      title: 'World of Sonam Label’s',
      heading: 'Honouring Craft, Elevating Couture Legacy',
      pagename: 'Craft Preservation',
    }

  return (
    <>
      <Subheader subheadData={subheadData}/>
      <CraftpreservationText/>
    </>
  )
}
